import I18nProvider from '@/lib/provider/I18nProvider'
import NewVersionToast from '@components/NewVersionToast.tsx'
import Title from '@components/designSystem/Title'
import Devtools from '@components/devtools/Devtools'
import { isDevMode, isIntegrationMode } from '@utils/env.ts'

import Router from './Router'
import CustomQueryClientProvider from './lib/provider/CustomQueryClientProvider'
import MediaGuard from './lib/provider/MediaGuard'
import SignInGuard from './lib/provider/SignInGuard'
import { ToastProvider } from './lib/provider/ToastProvider'
import UserGuard from './lib/provider/UserGuard'

function App() {
  return (
    <I18nProvider>
      <CustomQueryClientProvider>
        <ToastProvider>
          <MediaGuard>
            <Title />
            <SignInGuard>
              <UserGuard>
                <NewVersionToast />
                <Router/>
                {(isDevMode || isIntegrationMode) && <Devtools />}
              </UserGuard>
            </SignInGuard>
          </MediaGuard>
        </ToastProvider>
      </CustomQueryClientProvider>
    </I18nProvider>
  )
}

export default App